import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[AdminErrorBoundary] Admin render failed', error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6">
        <div className="w-full max-w-lg rounded-2xl border border-red-500/30 bg-slate-900 p-8 text-center">
          <AlertTriangle className="mx-auto mb-4 h-10 w-10 text-red-400" />
          <h1 className="text-xl font-semibold">Admin dashboard error.</h1>
          <p className="mt-2 text-sm text-slate-400">
            The admin interface encountered an unexpected error. No data was changed.
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="mt-6 inline-flex items-center gap-2 rounded-lg bg-slate-800 px-4 py-2 text-sm font-medium hover:bg-slate-700"
            data-testid="admin-error-boundary-retry"
          >
            <RefreshCw className="h-4 w-4" />
            Reload admin
          </button>
        </div>
      </div>
    );
  }
}
